// extracted by mini-css-extract-plugin
export default {"root":"EmailVerificationBanner_root__Myr+8","slideIn":"EmailVerificationBanner_slideIn__Jz8IR","button":"EmailVerificationBanner_button__k3miT"};